// @core/api/endpoints/tenant/update_tenant_onboarding.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantOnboardingResponse,
  UpdateTenantOnboardingRequest,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Update tenant onboarding progress
 * Marks onboarding steps as completed or skipped, and updates selected products/plans. Triggers events when all required steps are complete.
 */
export async function UpdateTenantOnboarding(
  tenant_id: string,
  data: UpdateTenantOnboardingRequest,
  options?: RequestOptions
): Promise<TenantOnboardingResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/onboarding`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.put<TenantOnboardingResponse>(requestPath, data, requestOptions);
}
